import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  nombreOrigen: "",
  codigoOrigen: "",
};

const nombreorigenSlice = createSlice({
  name: "nombreorigen",
  initialState: initialState,
  reducers: {
    ObtenerNombreOrigen: (state, actions) => {
      state.nombreOrigen = actions.payload.nombreOrigen;
      state.codigoOrigen = actions.payload.codigoOrigen;
    },

    CleanNombreOrigen: (state) => {
      state.nombreOrigen = "";
      state.codigoOrigen = "";
    },
  },
});

export const { ObtenerNombreOrigen, CleanNombreOrigen } = nombreorigenSlice.actions;

export default nombreorigenSlice.reducer;